module.exports = require('../dist/compat/object/merge.js').merge;
